/**
 * פורמט הקלדה/הדבקה לתאריך לידה DD/MM/YYYY — ספרות בלבד + "/" אוטומטי.
 * משותף לזרימת סוכנים (PassengerData) ולזרימת חבילות נופש / מיני-סייט (VacationPackagesPassengerData).
 *
 * @param {string|null|undefined} value — מחרוזת מהשדה (עם או בלי מפרידים)
 * @returns {string}
 */
export function formatDdMmYyyyTypedInput(value) {
  if (value == null || value === "") return "";
  const digits = String(value).replace(/\D/g, "");
  const limitedDigits = digits.slice(0, 8);
  let formatted = "";
  if (limitedDigits.length > 0) {
    formatted = limitedDigits.slice(0, 2);
    if (limitedDigits.length > 2) {
      formatted += "/" + limitedDigits.slice(2, 4);
    }
    if (limitedDigits.length > 4) {
      formatted += "/" + limitedDigits.slice(4, 8);
    }
  }
  return formatted;
}
